import { AppState } from '@app/store/reducer'

export const ctmNumberReadySelector = (state: AppState) => state.ui.isCtmNumberReady

// A/B testing
export const abTestVariantSelector = (state: AppState) => state.ui.abTestVariant
